import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '@/app/components/search/components/Form';
import { getMultilistboxValue } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetEntertainmentsField = {
  searchParams: SearchParams;
  t: TranslationFunction;
  commonProps: CommonProps;
};

export const getEntertainmentsOptions = ({ t, isWaiting }: { t: TranslationFunction; isWaiting?: boolean }) => [
  { value: 1, label: t('vacation.oss.filters.entertainments.zoo'), disabled: isWaiting },
  { value: 2, label: t('vacation.oss.filters.entertainments.ferris_wheel'), disabled: isWaiting },
  { value: 3, label: t('vacation.oss.filters.entertainments.oceanarium'), disabled: isWaiting },
  { value: 4, label: t('vacation.oss.filters.entertainments.dolphinarium'), disabled: isWaiting },
  { value: 5, label: t('vacation.oss.filters.entertainments.waterpark'), disabled: isWaiting },
  { value: 6, label: t('vacation.oss.filters.entertainments.lunapark'), disabled: isWaiting },
];

const getEntertainmentsField = ({ t, searchParams, commonProps }: GetEntertainmentsField): ControlProps => {
  const { isWaiting } = commonProps;

  return getListboxContainer({
    fieldName: URLParameters.ENTERTAINMENTS,
    containerName: FilterContainer.EntertainmentsContainer,
    containerTitle: t('vacation.oss.filters.entertainments.title'),
    options: getEntertainmentsOptions({ t, isWaiting }),
    value: getMultilistboxValue(searchParams[URLParameters.ENTERTAINMENTS], true),
    fieldClassName: '',
    ...commonProps,
  });
};

export default getEntertainmentsField;
